<template>
  <div id="modal-market" ref="vuemodal" class="modal fade">
    <div
      class="close-dialog dialog-mask mask"
      data-target="#dialog-market"
      @click.prevent="closeSelf"
    />
    <div class="modal-dialog modal-lg">
      <div class="cart-content modal-content">
        <a data-dismiss="modal" class="modal-close" href="#"><i class="icon-close2" /></a>
        <div v-if="dataisload" class="p-5">
          <div class="item-detail row">
            <div class="item-img col-md-5">
              <new-image
                v-if="selected.Images.length !== 0"
                :url="selected.Images[0].Url"
                :size="'_w480_h640'"
                :name="alldatas.Name"
              />
            </div>
            <div class="pt-3 col-md-7">
              <div class="item-name text-truncate h4 mb-2">{{ alldatas.Name }}</div>
              <div class="item-price h4">
                <span class="sell-price">
                  NT$
                  {{
                    alldatas.EventPrice > 0 && alldatas.EventPrice < alldatas.SellPrice
                      ? alldatas.EventPrice.toLocaleString()
                      : alldatas.SellPrice.toLocaleString()
                  }}
                </span>
                <span
                  v-if="alldatas.SellPrice !== alldatas.OriginPrice || alldatas.EventPrice > 0"
                  class="origin-price"
                >
                  NT$ {{ alldatas.OriginPrice.toLocaleString() }}
                </span>
              </div>
              <div v-for="event in alldatas.Events" :key="event.ID" class="my-2 text-info">
                <span>{{ event.Name }}</span>
              </div>
              <div class="item-pick mt-5">
                <div class="product-color-wrap mb-2">
                  <div
                    v-for="color in alldatas.Colors"
                    :key="color.ID"
                    class="product-color"
                    :class="{ active: color.ID === selected.ID }"
                    @click="changeImg(color.ID)"
                  >
                    <img :src="color.PintSizePictureUrl + '?w=16&h=16'" />
                  </div>
                </div>
                <Selector
                  class="size-selector mb-2"
                  :default-txt="'尺寸'"
                  :options="selected.Specs"
                  :selected="selectedSpec"
                  @cb="selectSpec"
                />
                <Selector
                  class="count-selector mb-2"
                  :default-txt="'數量'"
                  :selected="counter"
                  :options="counterOpts"
                  @cb="handleCount"
                />

                <div class="row">
                  <div class="col">
                    <div class="product-buttons m-0">
                      <a
                        class="btn btn-outline-primary w-100 btn-add-cart"
                        :class="btnStyleGenerate"
                        @click.prevent="addToCart"
                      >
                        <span>{{ btnDescriptionGenerate }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertDialog from '@global/helpers/alertDialog';
import NewImage from '@global/components/global/image';
import messageBox from '@global/helpers/messageBox';
import gtmTrace from '@global/components/tracing/gtm';
import Selector from '@page/common/js/template/select';
import store from '@global/components/store/index';
import { createNamespacedHelpers } from 'vuex';
import utmKDetect from '@global/helpers/utmKDetect';
import axios from 'axios';
import $ from 'jquery';
import { fireAddToCart } from '@global/gtm/common';

const { mapActions } = createNamespacedHelpers('miniCartModule');

export default {
  name: 'CartDialog',
  components: { NewImage, Selector },
  props: ['isnotice', 'btndescription'],
  data() {
    return {
      alldatas: {},
      selectedID: null,
      selected: {},
      hasstock: true,
      selectedSpec: { Name: '尺寸', Key: 'default' },
      selectedSpecID: null,
      selectedSpecKey: null,
      counter: { Name: '數量', Key: 'default' },
      btnStyle: 'disabled',
      btnDescription: this.btndescription.genernal,
      dataisload: false,
      itemSpecInfo: '',
      counterOpts: { Name: '數量', Key: 'default' },
    };
  },
  computed: {
    btnStyleGenerate: {
      get() {
        if (this.alldatas.IsPreShow) {
          this.btnStyle = 'disabled';
        } else if (!this.hasstock) {
          this.btnStyle = 'disabled';
        }

        return this.btnStyle;
      },
      set(newVal) {
        this.btnStyle = newVal;
      },
    },
    btnDescriptionGenerate: {
      get() {
        if (this.alldatas.IsPreShow) {
          this.btnDescription = this.btndescription.preShow;
        } else if (this.isnotice && !this.hasstock) {
          this.btnDescription = this.btndescription.notice;
        } else if (!this.hasstock) {
          this.btnDescription = this.btndescription.soldout;
        }

        return this.btnDescription;
      },
      set(newVal) {
        this.btnDescription = newVal;
      },
    },
  },
  watch: {
    selectedID() {
      this.getSelectedData();
    },
  },
  store,
  mounted() {
    $(this.$refs.vuemodal).on('hidden.bs.modal', (e) => {
      this.closeSelf();
    });
  },
  methods: {
    ...mapActions(['getCartInfo']),
    renderCounterOpts() {
      let c = [];
      let maxCount = 20;

      if (this.alldatas.Limit !== 0) {
        // 限購一件
        maxCount = 1;
      } else {
        // 檢查庫存
        this.selectedSpec.Stock < 20 ? (maxCount = this.selectedSpec.Stock) : (maxCount = 20);
      }

      for (let i = 0; i < maxCount; i++) {
        c.push({ Name: i + 1, Key: i + 1 });
      }

      this.counterOpts = c;
    },
    checkHasStock() {
      this.hasstock = false;

      this.selected.Specs.forEach((element) => {
        if (parseInt(element.Stock) !== 0) {
          this.hasstock = true;
        }
      });
    },
    getSelectedData() {
      this.alldatas.Colors.forEach((element) => {
        if (element.ID === this.selectedID) {
          this.selected = element;
        }
      });
    },
    closeSelf() {
      this.btnReset();
      this.clearSpec();
      this.resetCounter();
    },
    selectSpec(spec) {
      if (spec.Key === 'default') {
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.default;
        this.clearSpec();
        return;
      }
      this.selectedSpec = spec;
      this.selectedSpecID = spec.ID;
      this.selectedSpecKey = spec.Key;
      this.resetCounter();
      this.btnActive(spec.Stock, spec.IsOutOfStock, spec.PreOrder);
      this.renderCounterOpts();
    },
    clearSpec() {
      this.selectedSpec = { Name: '尺寸', Key: 'default' };
      this.selectedSpecID = null;
      this.selectedSpecKey = null;
      this.counterOpts = { Name: '數量', Key: 'default' };
    },
    resetCounter() {
      this.counter = { Name: '數量', Key: 'default' };
    },
    handleCount(c) {
      this.counter = c;
    },
    changeImg(colorID) {
      if (this.selected.ID === colorID) return;
      this.btnReset();
      this.clearSpec();
      this.resetCounter();
      this.selectedID = colorID;
    },
    btnActive(stock, isSoldOut, isPreOrder) {
      if (this.alldatas.IsPreShow) return;
      if (stock === 0 && isSoldOut && !isPreOrder) {
        // 現貨無庫存且斷貨
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.soldout;
      } else if (stock === 0 && !isPreOrder) {
        // 現貨無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else if (stock === 0 && isPreOrder) {
        // 預購無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else {
        this.btnStyleGenerate = 'active';
        this.btnDescriptionGenerate = this.btndescription.addbag;
      }
    },
    btnReset() {
      this.btnStyleGenerate = 'disabled';
      this.btnDescriptionGenerate = this.btndescription.genernal;
    },
    addToCart() {
      const custommarketid = this.alldatas.CustomMarketID;

      const itemSpecInfo = `${custommarketid.substring(0, custommarketid.indexOf('CL'))}CL${
        this.selectedID
      }SZ${this.selectedSpecKey}`;

      this.itemSpecInfo = itemSpecInfo;

      if (this.alldatas.IsPreShow) return;

      if (this.counter.Key === 'default' && this.selectedSpec.Stock !== 0) {
        AlertDialog.alert('請選擇數量!');
        return;
      }

      if (this.selectedSpec === null) {
        AlertDialog.alert('請選擇尺寸');
        return;
      }
      if (this.selectedSpec.Stock === 0 && this.isnotice) {
        return;
      }

      if (this.selectedSpec.Stock === 0) {
        return;
      }

      const utmData = utmKDetect(itemSpecInfo) === null ? '' : utmKDetect(itemSpecInfo);

      axios
        .post(API_URL.SHOPPING_CART, {
          CustomMarketID: itemSpecInfo,
          Count: this.counter.Key,
          UtmTag: utmData,
        })
        .then((res) => {
          if (res.data.Code === 200 || res.data.Code === 406) {
            messageBox.cart('商品確認<br>已加入購物車');
            this.getCartInfo();

            gtmTrace.addToCart({
              name: this.alldatas.Name,
              id: itemSpecInfo,
              price: this.alldatas.OriginPrice,
              sale_price:
                this.alldatas.EventPrice > 0 && this.alldatas.EventPrice < this.alldatas.SellPrice
                  ? this.alldatas.EventPrice
                  : this.alldatas.SellPrice,
              img_url: this.selected.Images[0].Url,
              product_url: this.selected.MarketUrl,
              color: this.selected.Name,
              count: this.counter,
            });

            fireAddToCart({
              item_id: itemSpecInfo.split('SZ')[0],
              item_name: this.alldatas.Name,
              index: 0,
              affiliation: this.selected.Name,
              item_brand: this.selectedSpec.Name,
              item_list_name: '願望清單',
              price:
                this.alldatas.EventPrice > 0 && this.alldatas.EventPrice < this.alldatas.SellPrice
                  ? this.alldatas.EventPrice
                  : this.alldatas.SellPrice,
              quantity: this.counter.Key,
              item_variant: this.selectedSpec.Barcode,
            });
          } else {
            AlertDialog.alert(res.data.Message);
          }
        })
        .catch(() => {
          AlertDialog.alert('系統忙線中，請稍後再試');
        });
    },
  },
};
</script>

<style></style>
